const gForm = () => {
  const gFormConfiguration = () => {
    const items = document.querySelectorAll(
      ".atom-gform .gfield:not(.hidden_label, .uploadfile, .gfmc-field)"
    );

    items.forEach((item) => {
      if (!item.querySelector("input, textarea")) {
        return;
      }
      item.insertBefore(
        item.querySelector("input, textarea"),
        item.childNodes[0]
      );
      if (item.querySelector(".ginput_container")) {
        item.querySelector(".ginput_container").remove();
      }
    });
  };

  gFormConfiguration();

  const gForm = document.querySelectorAll(".atom-gform");

  // Manage Submit Button
  gForm.forEach((elem) => {
    let dom = new DOMParser().parseFromString(
      '<span data-type="icon" data-temp="ico-plus.twig" class="ico-frame is-red ico-plus"><span class="screen-reader-text">Up</span></span>',
      "text/html"
    );
    let footer = elem.querySelector(".gform_footer.top_label");
    let submit = elem.querySelector('input[type="submit"]');
    footer.classList.add("a");
    let new_element = dom.body.firstElementChild;
    footer.appendChild(new_element);

    submit.addEventListener("click", () => {
      setTimeout(() => {
        let footer = elem.querySelector(".gform_footer.top_label");
        footer.appendChild(new_element);
        renderGForm();
      }, 2000);
    });
  });
};

export { gForm as default };
